import {AppConstants} from '../app.constants';

export class AppLocalStorage {

    private static appLocalStorageKey(key: string): string {
        return `${AppConstants.APP_LOCAL_STORAGE_KEY}.${key}`;
    }

    static getItem(key: string): string | null {
        return localStorage.getItem(AppLocalStorage.appLocalStorageKey(key));
    }

    static removeItemByKey(key: string): void {
        localStorage.removeItem(AppLocalStorage.appLocalStorageKey(key));
    }

    static getBooleanItem(key: string): boolean | null {
        const value = AppLocalStorage.getItem(key);
        return value == null ? null : value === 'true';
    }

    static getNumberItem(key: string): number | null {
        const value = AppLocalStorage.getItem(key);
        return value == null ? null : Number(value);
    }

    static setItem(key: string, value: any): void {
        if (value == null) {
            AppLocalStorage.removeItemByKey(key);
        } else {
            localStorage.setItem(AppLocalStorage.appLocalStorageKey(key), value?.toString());
        }
    }

    static setNumberItem(key: string, value: number | null): void {
        AppLocalStorage.setItem(key, value?.toString());
    }

    static getJsonItem(key: string): any {
        const item = localStorage.getItem(AppLocalStorage.appLocalStorageKey(key));
        return item ? JSON.parse(item) : null;
    }

    static setJsonItem(key: string, value: any): void {
        if (value == null) {
            AppLocalStorage.removeItemByKey(key);
        } else {
            AppLocalStorage.setItem(key, JSON.stringify(value));
        }
    }

    static clear(): void {
        localStorage.clear();
    }
}


export class AppSessionStorage {

    private static AppSessionStorageKey(key: string): string {
        return `${AppConstants.APP_LOCAL_STORAGE_KEY}.${key}`;
    }

    static getItem(key: string): string | null {
        return sessionStorage.getItem(AppSessionStorage.AppSessionStorageKey(key));
    }

    static removeItemByKey(key: string): void {
        sessionStorage.removeItem(AppSessionStorage.AppSessionStorageKey(key));
    }

    static getBooleanItem(key: string): boolean | null {
        const value = AppSessionStorage.getItem(key);
        return value == null ? null : value === 'true';
    }

    static getNumberItem(key: string): number | null {
        const value = AppSessionStorage.getItem(key);
        return value == null ? null : Number(value);
    }

    static setItem(key: string, value: any): void {
        if (value == null) {
            AppSessionStorage.removeItemByKey(key);
        } else {
            sessionStorage.setItem(AppSessionStorage.AppSessionStorageKey(key), value?.toString());
        }
    }

    static setNumberItem(key: string, value: number | null): void {
        AppSessionStorage.setItem(key, value?.toString());
    }

    static setBooleanItem(key: string, value: boolean | null): void {
        AppSessionStorage.setItem(key, value?.toString());
    }

    static getJsonItem(key: string): any {
        const item = sessionStorage.getItem(AppSessionStorage.AppSessionStorageKey(key));
        return item ? JSON.parse(item) : null;
    }

    static setJsonItem(key: string, value: any): void {
        if (value == null) {
            AppSessionStorage.removeItemByKey(key);
        } else {
            AppSessionStorage.setItem(key, JSON.stringify(value));
        }
    }

    static clear(): void {
        sessionStorage.clear();
    }
}
